import { Input as MTInput } from "@material-tailwind/react";
interface inputType {
  handleChange: any;
  value: any;
  labelText: string;
  labelFor: string;
  id: string;
  name: string;
  type: string;
  isRequired: boolean;
  placeholder: string;
  customClass: string;
  disabled?: boolean;
  error?: boolean;
}

function Input(props: inputType) {
  return (
    <>
      {/* <div className="my-5">
        <label htmlFor={props.labelFor} className="sr-only">
          {props.labelText}
        </label>
        <input
          onChange={props.handleChange}
          value={props.value}
          id={props.id}
          name={props.name}
          type={props.type}
          required={props.isRequired}
          className={fixedInputClass + props.customClass}
          placeholder={props.placeholder}
        />
      </div> */}

      <div className="my-5">
        <MTInput
          onChange={props.handleChange}
          value={props.value}
          label={props.labelText}
          id={props.id}
          name={props.name}
          type={props.type}
          required={props.isRequired}
          disabled={props.disabled}
          error={props.error}
          size="lg"
          crossOrigin={undefined}
        />
      </div>
    </>
  );
}
export default Input;
